// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NyXc5","top":"styles_top__2-2ij","left":"styles_left__1-doU","description":"styles_description__3VDoB"};